import { constants } from '../config';
import { NumberHelper } from './NumberHelper';

class ProductHelper {
  static priceFor(product, hasService) {
    const productPrice = product.financing.price;
    if (hasService && product.serviceProduct) {
      return productPrice + product.serviceProduct.financing.price;
    }
    return productPrice;
  }

  static priceStringFor(product, hasService) {
    return NumberHelper.localizeNumber(ProductHelper.priceFor(product, hasService));
  }

  static findInstallationTextFor(serviceProduct) {
    const { characteristics } = serviceProduct;
    let installationText = null;
    characteristics.forEach((char) => {
      char.characteristics.forEach(({ id, value }) => {
        // The installation text comes embedded in a specific
        // characteristic of the product with a known ID.
        if (id === constants.installationTextCharacteristicId) {
          installationText = value;
        }
      });
    });
    return installationText;
  }

  static findConditionForSale(product) {
    if (product != null && product.characteristics) {
      const waranty = product.characteristics.find(item => item.name === 'Garantía');
      if (waranty && waranty.characteristics) {
        const data = waranty.characteristics.find(item => item.key === 'Condición');
        return data.value[0].entries[0].text;
      }
    }
    return null;
  }
}

export { ProductHelper };



// WEBPACK FOOTER //
// ./src/helpers/ProductHelper.js